<template>
  <tk-flex
    v-if="currentEqs.length === 0"
    class="width-full"
    style="height: 500px"
    middle
    center
  >
    <a-empty></a-empty>
  </tk-flex>
  <div v-else>
    <a-card class="m-t-20">
      <tk-flex middle between>
        <div class="font-bold">粮虫曲线图</div>
        <tk-flex middle>
          <a-select
            allowClear
            placeholder="所有点位"
            v-model="selectPoint"
            style="width: 120px;"
          >
            <a-select-option
              :value="item.value"
              v-for="item in pointSelect"
              :key="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
          <span class="m-r-10 m-l-15">开始时间</span>
          <DateSelect v-model="timeRange[0]" />
          <span class="m-r-10 m-l-15">结束时间</span>
          <DateSelect v-model="timeRange[1]" />
          <!-- <a-range-picker v-model="timeRange" class="m-l-10" :allowClear="false">
            <a-icon slot="suffixIcon" type="calendar" />
          </a-range-picker> -->
        </tk-flex>
      </tk-flex>
      <ve-chart
        v-if="height"
        :options="options"
        :style="{ height: height + 'px' }"
        style="width: 100%;"
        ref="chat"
      />
    </a-card>
  </div>
</template>
<script>
import 'echarts/lib/chart/line'
import moment from 'moment'
import DateSelect from './dateSelect'

export default {
  components: {
    DateSelect
  },
  props: {
    lasteTimeTag: {
      type: String,
      default: ''
    },
    storeInfo: {
      type: Object,
      required: true
    },
    allCurrnetPo: {
      type: Array,
      required: true
    },
    currentEqs: {
      type: Array,
      required: true
    },
    isRequestPoint: {
      type: Boolean,
      required: true
    },
    pointsRes: {
      type: Array,
      required: true
    },
    storeBugNum: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selectPoint: undefined,
      height: null,
      timeRange: [moment().startOf('month'), moment().endOf('month')],
      datas: [],
      options: {
        title: {
          show: false
        },
        tooltip: {},
        dataset: {
          source: [[], []]
        },
        xAxis: [{ type: 'category', gridIndex: 0 }],
        yAxis: [{ gridIndex: 0 }],
        grid: [{ bottom: '10%', left: 60, right: 50 }],
        series: [
          {
            type: 'line',
            seriesLayoutBy: 'row',
            itemStyle: { color: '#2FBF79' }
          }
        ]
      }
    }
  },
  computed: {
    pointSelect () {
      return this.allCurrnetPo.map(element => {
        return {
          value: element.objectId,
          name: element.index + '号点位'
        }
      })
    },
    dateList () {
      const startTime = moment(this.timeRange[0]).startOf('day')
      const endTime = moment(this.timeRange[1]).endOf('day')
      const days = endTime.diff(startTime, 'day') + 1
      const arr = []
      for (let index = 0; index < days; index++) {
        const currentTime = moment(startTime).add(index, 'days')
        arr.push(currentTime)
      }
      return arr
    }
  },
  watch: {
    selectPoint () {
      this.getData()
    },
    timeRange () {
      this.getData()
    }
  },
  methods: {
    async getData () {
      if (this.selectPoint) {
        await this.getPointData()
      } else {
        await this.getStroeData()
      }
      this.updateOptions()
    },
    async getStroeData () {
      const res = await this.$tkParse.get('/aggregate/dayStoreResult', {
        params: {
          group: {
            objectId: {
              day: { $dayOfMonth: '$date' },
              month: { $month: '$date' },
              year: { $year: '$date' } // 把创建时间的年月日作为分组条件，即代表按天分组
            },
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: '$bugNum' // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: {
            store: this.storeInfo.objectId,
            date: {
              $gt: this.timeRange[0].clone().startOf('day').toISOString(),
              $lte: this.timeRange[1].clone().endOf('day').toISOString()
            }
          }
        }
      })
      this.datas = res.data.results
    },
    async getPointData () {
      const res = await this.$tkParse.get('/aggregate/testResults', {
        params: {
          group: {
            objectId: {
              day: { $dayOfMonth: '$date' },
              month: { $month: '$date' },
              year: { $year: '$date' } // 把创建时间的年月日作为分组条件，即代表按天分组
            },
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: '$bugNum' // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: {
            time: this.lasteTimeTag,
            drop: this.selectPoint,
            date: {
              $gt: this.timeRange[0].clone().startOf('day').toISOString(),
              $lte: this.timeRange[1].clone().endOf('day').toISOString()
            }
          }
        }
      })
      this.datas = res.data.results
    },
    updateOptions () {
      const dates = this.createDateListOptions()
      const datas = this.createDataOptions()
      this.options = {
        title: {
          show: false
        },
        tooltip: {},
        dataset: {
          source: [
            ['日期', ...dates],
            ['粮虫数量', ...datas]
          ]
        },
        xAxis: [{ type: 'category', gridIndex: 0 }],
        yAxis: [{ gridIndex: 0 }],
        grid: [{ bottom: '10%', left: 80, right: 50 }],
        series: [
          {
            type: 'line',
            seriesLayoutBy: 'row',
            itemStyle: { color: '#2FBF79' }
          }
        ]
      }
    },
    createDateListOptions () {
      return this.dateList.map(
        element => `${element.month() + 1}.${element.date()}`
      )
    },
    createDataOptions (arr) {
      const values = new Array(this.dateList.length).fill(0)
      this.datas.forEach(element => {
        const dataDate = moment()
          .year(element.objectId.year)
          .month(element.objectId.month - 1)
          .date(element.objectId.day)
        const index = this.dateList.findIndex(ele =>
          dataDate.isSame(ele, 'day')
        )
        if (index > -1) {
          values[index] = element.total
        }
      })
      return values
    },
    async getAllDays () {
      const res = await this.$tkParse.get('/aggregate/dayEq', {
        params: {
          group: {
            objectId: {
              arr: { $dayOfMonth: '$date' }
            }, // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1 // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: {
            date: {
              $gte: moment(this.timeRange[0])
                .startOf('month')
                .toISOString(),
              $lt: moment(this.timeRange[0])
                .endOf('month')
                .toISOString()
            },
            grainstore: this.storeId
          } // 查询条件
        }
      })
      const days = res.data.results
        .map(item => item.objectId.arr)
        .sort((a, b) => b - a)
      if (days.length > 0) {
        this.timeRange[1] = moment(this.timeRange[1]).date(days[0]).endOf('day')
      }
    }
  },
  async mounted () {
    this.height = document.body.clientHeight * 0.7
    await this.getAllDays()
    this.getData()
  }
}
</script>
<style scoped>
::v-deep .ant-card-small > .ant-card-body {
  padding: 0px;
}
</style>
